import { IssueType, NatureOfComplaintInternational, ReviewResult, RootCause, Through } from '../../../../enums';
import { ICodReview } from './cod-review.interface';

export interface IInvestigatorReviewInt extends ICodReview {
    reviewResult: ReviewResult;
    natureOfComplaint?: NatureOfComplaintInternational;
    issueType?: IssueType;
    rootCause?: RootCause;
    through: Through;
    details?: string;
}
